import fetch from '../../api/fetch';
import { API_URL } from '../../shared/config/config';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { UNIT_SYSTEM } from '../../shared/config/hydraulics_constants';
import { VERSION } from '../../shared/config/version';
import { parseError } from '../../utils/fetchErrorParser';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listRealtimeCollections = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_LOADING,
  });

  const body = {};

  return fetch
    .post('mongo/collectionStats/accDrill', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_SUCCESS,
        payload: {
          realtimeCollections: data,
          paginatedElements: data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const downloadRealtimeCollection = (collectionName, active = true) => (dispatch) => {
  const { currentUser } = store.getState();

  let iframe = document.getElementById('download-iframe');
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.id = 'download-iframe';
    iframe.name = 'download-iframe';
    document.body.appendChild(iframe);
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${API_URL}mongo/downloadCollection`;
  form.target = 'download-iframe';

  const payloadObj = {
    input: { collectionName, active },
    user: {
      type: currentUser?.type,
      accessLevels: currentUser?.accessLevels,
      companyId: currentUser?.companyId,
      userId: currentUser?.userId,
      unitSystem: currentUser?.preferences?.unitSystem || UNIT_SYSTEM.US,
      version: VERSION
    },
  };
  const payloadInput = document.createElement('input');
  payloadInput.name = 'payload';
  payloadInput.value = JSON.stringify(payloadObj);
  form.appendChild(payloadInput);

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

  dispatch(
    enqueueSnackbar(
      `Download started for ${collectionName}`,
      'info',
      Date.now() + Math.random()
    )
  );
};

export const archiveRealtimeCollection = (collectionName, details, closeAlert) => (dispatch) => {
  closeAlert();
  dispatch({
    type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_LOADING,
  });

  const body = {
    input: {
      collectionName,
      details
    }
  };
  return fetch
    .downloadPost('mongo/archiveCollection', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result;
    })
    .then(() => {
      dispatch({
        type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_LOADING_FINISH,
      });
      dispatch(listRealtimeCollections());
      dispatch(
        enqueueSnackbar(
          `${collectionName} has been successfully archived`,
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch({
        type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const downloadRealtimeCSV = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_LOADING,
  });

  const body = {};

  const path = 'mongo/collectionStats/accDrill/downloadCSV';
  return fetch
    .post(path, body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      // Convert JSON data to CSV format
      const blob = new Blob([data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'realtime_collections.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      dispatch({
        type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_LOADING_FINISH,
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
